<template>
  <div>
    <div class="float-right" v-if="room.detailSelected.AmountAfterTax != room.detailSelected.priceInit || !room.rates.length ">
      <b-button
        size="sm"
        variant="warning"
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        v-b-tooltip.hover.top="'Regresar a tarifa original'"
        @click="priceMatchInitial"
      > <feather-icon icon="RotateCcwIcon"/>
      </b-button>
    </div>

    <b-tabs v-if="room.rates.length" >
      <b-tab active title="Descuento" v-if="room.detailSelected.AmountAfterTax > 0">
        <PriceMatchPromoCode
          :isLoadingRates="isLoadingRates"
          :room="room"
          @check-price-match-by-promotion-code="priceMatchRoom"
          @price-match-initial="priceMatchInitial"
          @update-booking="updateMyBooking"
        />
      </b-tab>
      <!-- -->
      <b-tab title="Price Match / Tarifa límite" v-if="room.detailSelected.allowPriceMatch && room.detailSelected.AmountAfterTax > 0">
        <PriceMatchManualPrice
          :isLoadingRates="isLoadingRates"
          :room="room"
          @check-price-match-by-promotion-code="priceMatchRoom"
          @update-booking="updateMyBooking"
        />
      </b-tab>

      <b-tab active title="Tarifa" v-if="room.detailSelected.AmountAfterTax == 0">
        <div>
          <strong>Tarifa inicial: </strong>
          <b-badge variant="warning" >
            {{formatAmount(room.priceInit)}}
          </b-badge>
        </div>
        <div class="mb-1">
          <strong>Total: </strong>{{ formatAmount(room.detailSelected.AmountAfterTax)}}
        </div>
        <div class="float-right" v-if="room.rates.length">
          <b-button
            variant="primary"
            @click="updateBooking"
            :disabled="!room.showingRates"
          >
            <feather-icon icon="SaveIcon" size="16" /> Actualizar
          </b-button>
        </div>
      </b-tab>
    </b-tabs>
    <b-tabs v-if="!room.rates.length">
      <b-tab active title="Sín tarifas" ></b-tab>
        <b-alert show variant="danger" class="mt-2">
          <div class="alert-body text-center"> <span>Su busqueda no encontró tarifas para esta habitación, click en el botón de regresar a tarifa original e intente con otra opcion de tarifas </span></div>
        </b-alert>
    </b-tabs>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// Helpers
import { toJson, showAlertMessage, toCurrency } from '@/helpers/helpers'
import { formatInfoRates } from '@/helpers/mySalesHelper'
import { setGuestsInPayload } from "@/helpers/shopHelper"

//components

import Ripple from 'vue-ripple-directive'
import PriceMatchPromoCode from '@/modules/mySales/components/orderDetail/bookings/PriceMatchPromoCode'
import PriceMatchManualPrice from '@/modules/mySales/components/orderDetail/bookings/PriceMatchManualPrice'


export default {
  directives: {
    Ripple,
  },
  props: {
    room:{
      type: Object,
			required: true
		},
    isLoadingRates:{
      type: Boolean,
      required: true,
    }
	},
  components:{
    PriceMatchPromoCode,
    PriceMatchManualPrice
  },
  computed:{
    ...mapState('mySales',['searchForm','bookingSelected','userAuthUpdateBooking']),
    ...mapState('auth',['user']),
  },
  methods:{
    ...mapActions('mySales',['fetchRoomPriceMatch']),
    ...mapMutations('mySales',['setRoomsBookingSelected']),
    async priceMatchRoom( data ){
      data.allowPriceMatch = data.isManualRate // si es isManualRate, allowPriceMatch es true
      this.$emit('set-is-loading-rates', true)
      const rooms = await this.fetchRoomPriceMatch(data) //pido nuevas tarifas
      this.setRoomsBookingSelected(rooms)
      this.$emit('set-is-loading-rates', false)
    },
    async priceMatchInitial(){
      //armo bien el payload
      const payload = toJson({...this.searchForm })
      const roomCode = this.room.detailSelected.RoomTypeCode || this.room.RoomTypeCode
      payload.promoCodeManual = this.bookingSelected.promotioncode
      payload.promotionCode = this.bookingSelected.promotioncode
      payload.roomCode = roomCode
      payload.keyRoom = this.room.keyRoom, //lo ocupo de manera interna
      payload.priceInit = this.room.priceInitDefault, //lo ocupo de manera interna
      payload.allowPriceMatch = true
      delete payload.manualRate
      this.$emit('set-is-loading-rates', true)
      // console.log( payload )
      const rooms = await this.fetchRoomPriceMatch( payload ) //se pide las tarifas del room originales
      this.setRoomsBookingSelected(rooms)
      this.$emit('set-is-loading-rates', false)
    },
    async updateMyBooking( params ){
      const { authorizationUser, dateAuthorization, isAuthorization, isRateLimit, urlAuthorization } = params
      const { id, email, firstpay, givenname, hotel, inclusions, nameprefix, phonenumber,
             surname, termscondition, order, orderDetail, partial, urlimage, dingusbooking, guests, vendor } = this.bookingSelected
      const { multimedias, RoomTypeName } = this.room //
      const { ninos, adults, children, dateIn, dateOut, idioma, nights } = this.searchForm
      const { MealPlanCodes, PromotionCode, priceInit, manualPrice, RatePlanCode, RatePlanID, MealPlanDescription, RoomTypeCode, InfoRates } = this.room.detailSelected
      const manualPriceFormat = manualPrice != '' ? parseFloat(manualPrice) : '0'
			const infoRates = ( InfoRates && InfoRates.length ) ? InfoRates : []

      let arrayNinios = []
      if( ninos && ninos.length > 0){
        ninos.forEach( (edad) => {
          arrayNinios.push(edad)
        })
      }
      const payloadBooking = {
        adults,
        authorizationUser,
        children,
        guests: setGuestsInPayload(guests),
        dateAuthorization, // es nulo por defecto, fecha tiene valor solo si viene de modal de autorización,
        datein: dateIn,
        dateout: dateOut,
        dingusbooking,
        email,
        firtpay: firstpay,
        givenname,
        hotel,
        id, //propiedad extra, lo requiero para armar el payload, es el id del item (del booking)
        inclusions, // viene en el el booking selected
        inforates: formatInfoRates(infoRates) , //nuevo valor
        isAuthorization, // si hay idUserAutoriza es true, sino false
        isRateLimit, // false por defecto, setear true si este viene con el check desde pricematch en tab2
        language: idioma,
        mealplancode: MealPlanCodes,
        multimedias: toJson(multimedias) || null,
        nameprefix: guests.adults?.find( guest => guest.mainGuest )?.NamePrefix || nameprefix,
        nights,
        ninos: toJson(arrayNinios),
        order, //propiedad extra, lo requiero para armar el payload, el numero de order
        orderDetail, //propiedad extra, lo requiero para armar el payload, el numero de order
        partial: partial || false, // boolean, sino viene sería false
        phonenumber,
        promotioncode: PromotionCode,
        rateInit: priceInit,
        rateManual: manualPriceFormat,
        rateplancode: RatePlanCode,
        rateplanid: RatePlanID,
        rateplanname: MealPlanDescription,
        roomtypecode:RoomTypeCode,
        roomtypename: RoomTypeName,
        surname,
        termscondition: termscondition || null, //sino viene con valor, sería nulo
        total: this.room.detailSelected.AmountAfterTax,
        urlAuthorization, // img si sucede autorizacion, va la url
        urlimage,
        vendorcode: vendor || '',
      }

      const payloadFinal = { ordersdetail: orderDetail, bookingid: id, order, orderbooking: payloadBooking }

      this.$emit("update-booking", payloadFinal)
    },
    async updateBooking() {
      const payload = {
        authorizationUser: "",
        dateAuthorization: null,
        isAuthorization: false,
        isRateLimit: false,
        urlAuthorization: "",
      };
      await this.updateMyBooking(payload)
    },
    formatAmount(amount){
      return toCurrency(amount)
    },
  }
}
</script>